import * as angular from "angular";

angular
  .module('bringoz.admin.auctions')
  .constant('Auctions_PN', {
    database: 'auctions',
    isBranchEntity: false
  });
